import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { PartnerDetails } from '@gn-audio/jss-core';

import Drawer from 'common/components/Drawer/Drawer';

import { ExpertiseImageFields } from './constants';
import PartnerDetailsExpertise from './PartnerDetailsExpertise';
import PartnerDetailsLoader from './PartnerDetailsLoader';

type PartnerLocatorDetailsProps = {
  fields: ExpertiseImageFields;
  partnerDetails: PartnerDetails | null;
  authIdTitle?: Field<string>;
  addressTitle?: Field<string>;
  websiteTitle?: Field<string>;
  phoneTitle?: Field<string>;
  showDetails: boolean;
  setShowDetails: (show: boolean) => void;
  areDetailsLoading: boolean;
};

export const PartnerLocatorDetails = ({
  fields,
  partnerDetails,
  authIdTitle,
  addressTitle,
  websiteTitle,
  phoneTitle,
  showDetails,
  setShowDetails,
  areDetailsLoading,
}: PartnerLocatorDetailsProps) => {
  return (
    <Drawer
      title={partnerDetails?.name}
      size="s"
      open={showDetails}
      close={() => setShowDetails(false)}
    >
      <div className="p-8">
        {areDetailsLoading ? (
          <PartnerDetailsLoader />
        ) : (
          partnerDetails && (
            <div>
              <h2 className="mb-8 break-words text-4xl font-bold">{partnerDetails?.name}</h2>

              <PartnerDetailsExpertise partner={partnerDetails} fields={fields} />

              <div className="mb-4">
                <h3 className="text-lg font-semibold">{authIdTitle?.value}</h3>
                <p className="text-sm text-gray-900">{partnerDetails?.authId}</p>
              </div>
              <div className="mb-4">
                <h3 className="text-lg font-semibold">{addressTitle?.value}</h3>
                <p className="text-sm text-gray-800">{partnerDetails?.address1}</p>
                <p className="text-sm text-gray-800">{partnerDetails?.address2}</p>
                <p className="text-sm text-gray-800">{partnerDetails?.city}</p>
                <p className="text-sm text-gray-800">{partnerDetails?.zip}</p>
              </div>
              <div className="mb-4">
                <h3 className="text-lg font-semibold">{websiteTitle?.value}</h3>
                <a
                  href={
                    partnerDetails?.website?.startsWith('http')
                      ? partnerDetails.website
                      : `https://${partnerDetails?.website}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="break-all text-sm text-gray-700 hover:text-gray-900"
                >
                  {partnerDetails?.website}
                </a>
              </div>
              <div className="mb-4">
                <h3 className="text-lg font-semibold">{phoneTitle?.value}</h3>
                <p className="text-sm text-gray-900">{partnerDetails?.phone}</p>
              </div>
            </div>
          )
        )}
      </div>
    </Drawer>
  );
};
